import Vue from 'vue';
import VueRouter from 'vue-router';
// import Loading from '@/components/Loading.vue';
import Index from '@/components/Index.vue';
import ArticlesList from '@/components/ArticlesList.vue';
import VideoList from '@/components/VideoList.vue';
import Play from '@/components/play.vue';
import team from '@/components/team.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/Index',
        name: 'Index',
        component: Index
    },
    {
        path: '/',
        name: 'Index',
        component: Index
    },
    {
        path: '/Articles',
        name: 'ArticlesList',
        component: ArticlesList
    },
    {
        path: '/Video',
        name: 'VideoList',
        component: VideoList
    },
    {
        path: '/Play',
        name: 'Play',
        component: Play
    },
    {
        path: '/team',
        name: 'team',
        component: team
    }
];

const router = new VueRouter({
    // mode: 'history',
    // base: '/',
    routes
});

export default router;
